import React, { forwardRef } from 'react';

import clsx from 'clsx';

import styles from './Checkbox.module.scss';

export enum CheckboxType {
  Primary = 'Primary',
  Alternative = 'Alternative',
  AlternativeBordered = 'AlternativeBordered',
}

interface CheckboxProps {
  type: CheckboxType;
  name: string;
  onClick?: () => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isChecked?: boolean;
  text?: string | JSX.Element;
  className?: string;
  isValid?: boolean;
  noInteraction?: boolean | null;
  labelClassName?: string;
  disabled?: boolean;
}

const labelStylesByType = {
  [CheckboxType.Primary]: styles.checkboxLabelPrimary,
  [CheckboxType.Alternative]: styles.checkboxLabelAlternative,
  [CheckboxType.AlternativeBordered]: styles.checkboxLabelAlternativeBordered,
};

const checkboxStylesByType = {
  [CheckboxType.Primary]: styles.checkboxPrimary,
  [CheckboxType.Alternative]: styles.checkboxAlternative,
  [CheckboxType.AlternativeBordered]: styles.checkboxAlternativeBordered,
};

const errorStylesByType = {
  [CheckboxType.Primary]: styles.checkboxLabelPrimaryError,
  [CheckboxType.Alternative]: styles.checkboxLabelAlternativeError,
  [CheckboxType.AlternativeBordered]: styles.checkboxLabelAlternativeBordered,
};

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      name,
      type,
      onClick,
      onChange,
      className,
      isChecked = false,
      text,
      isValid = true,
      noInteraction,
      labelClassName,
      disabled,
    }: CheckboxProps,
    ref,
  ) => {
    const isPrimary = type === CheckboxType.Primary;

    return (
      <label
        className={clsx(labelStylesByType[type], labelClassName, isValid || errorStylesByType[type], {
          [styles.labelNoInteraction]: noInteraction,
        })}
      >
        <input
          type={isPrimary ? 'radio' : 'checkbox'}
          name={name}
          onClick={onClick}
          onChange={onChange}
          checked={isChecked}
          disabled={disabled}
          ref={ref}
        />
        <div className={checkboxStylesByType[type]} />
        <p className={clsx(styles.text, className, { [styles.labelNoInteraction]: noInteraction })}>{text}</p>
      </label>
    );
  },
);

export default Checkbox;
